import type { ApiScopeBase } from '../api/ApiScopes';
import { makeTypeGuardByProperty } from '../types/makeTypeGuardByProperty';
import { safeAbsurd } from '../types/safeAbsurd';

export type ApiScopeRequirementAnd = { and: ApiScopeRequirement[] };
export type ApiScopeRequirementOr = { or: ApiScopeRequirement[] };

export type ApiScopeRequirement =
  | ApiScopeBase
  | ApiScopeRequirementAnd
  | ApiScopeRequirementOr;

export const isApiScopeRequirementAnd = makeTypeGuardByProperty<
  ApiScopeRequirement,
  ApiScopeRequirementAnd
>('and');
export const isApiScopeRequirementOr = makeTypeGuardByProperty<
  ApiScopeRequirement,
  ApiScopeRequirementOr
>('or');
export const isApiScopeRequirementBase = makeTypeGuardByProperty<
  ApiScopeRequirement,
  ApiScopeBase
>('path');

export const meetsApiScopeRequirement =
  (isScopeAllowed: (scope: ApiScopeBase) => boolean) =>
  (requirement: ApiScopeRequirement): boolean => {
    if (isApiScopeRequirementAnd(requirement)) {
      return requirement.and.every(meetsApiScopeRequirement(isScopeAllowed));
    }
    if (isApiScopeRequirementOr(requirement)) {
      return requirement.or.some(meetsApiScopeRequirement(isScopeAllowed));
    }
    if (isApiScopeRequirementBase(requirement)) {
      return isScopeAllowed(requirement);
    }

    safeAbsurd(requirement);
    return false;
  };
